<template>
    <v-autocomplete
            multiple
            v-model="searchModels"
            :items="itemsList"
            :chips="hasChips"
            hide-no-data
            item-text="name"
            item-value="value"
            :label="componentLabel"
            @change="valueChange"
            return-object
            color="orange lighten-2"
    >
        <template v-slot:selection="data" v-if="hasChips">
            <v-chip
                    :input-value="data.selected.id"
                    close
                    color="grey"
                    outlined
                    @click="data.selected"
                    @click:close="remove(data.item.id)"
            >
                {{ data.item.name }}
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script>
    import BaseSimpleAutocomplete from '../../../general/mixins/BaseSimpleAutocomplete';

    export default {
        name: "ManufacturerSimple",
        props:['categoryId'],
        mixins:[BaseSimpleAutocomplete],
        data() {
            return {
                params: {
                    categoryId: this.categoryId
                }
            }
        },
        computed: {
            currentCategory() {
                return this.categoryId;
            },
            filterName() {
                return this.$store.state.filters.general.manufacturer.systemName;
            }
        },
        methods: {
            initSearchParams() {
                this.params = {};
                this.params.categoryId = this.currentCategory;
            },
            setServiceState(){
                this.apiService.setManufacturerSearch();
            },
        },
        created() {
            this.initSearchParams();
        },
        watch: {
            currentCategory() {
                this.searchModel = null;
                this.searchModels = [];
            }
        }
    }
</script>

<style scoped>

</style>
